import * as types from '@/store/mutationTypes';

export const actions = {
    toggleConfirmationModal: async ({ commit }, payload) => {
        commit(types.SET_IS_CONFIRM_SHOWN, payload);
        commit(types.SET_IS_FADE_SHOWN, payload);
    },
    toggleFade: async ({ commit }, payload) => {
        commit(types.SET_IS_FADE_SHOWN, payload);
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/confirmModal/actions.js